import { render } from "./GraphQL-SSRDemo.vue?vue&type=template&id=37a235f8"
import script from "./GraphQL-SSRDemo.vue?vue&type=script&lang=js"
export * from "./GraphQL-SSRDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__